"use client"

import * as React from "react"

import { createPersistedStore, usePersistedStore } from "@/lib/persisted-store"
import { DEFAULT_EXAM_CATEGORIES } from "@/lib/exam-categories/defaults"
import { seedCourseAssignments, type CourseAssignments } from "@/lib/exam-categories/course-assignment"
import { LIBRARY_FOLDERS } from "@/lib/mock/library"

export const COURSE_ASSIGNMENTS_STORE_KEY = "shell:category-course-assignments:v1"

const store = createPersistedStore<CourseAssignments>(COURSE_ASSIGNMENTS_STORE_KEY, () =>
  seedCourseAssignments(LIBRARY_FOLDERS, DEFAULT_EXAM_CATEGORIES),
)

/** Which courses each top-level category and standard applies to. One store for Settings and the editor. */
export function useCourseAssignments() {
  const [assignments, set] = usePersistedStore(store)
  /** `null` means every course. */
  const setCourses = React.useCallback(
    (rootId: string, courseIds: string[] | null) =>
      set((current) => {
        const { [rootId]: _prev, ...rest } = current
        return courseIds === null ? rest : { ...rest, [rootId]: courseIds }
      }),
    [set],
  )
  return { assignments, setCourses }
}
